import { schema, types } from 'papr'

export const userSwagSchema = schema({
	user: types.objectId({ required: true }),
	status: types.enum(['eligible' as const, 'claimed' as const]),
	type: types.enum(['product_referral_ambassador' as const]),
	dateClaimed: types.date(),
	rewardMeta: types.object({
		post: types.objectId(),
	}),
})

export type UserSwagDocument = (typeof userSwagSchema)[0]
export type UserSwagDefaults = (typeof userSwagSchema)[1]
